import type { FeatureFlagKey } from '@/constants/types';
import useFeatureFlags from '@/hooks/useFeatureFlags';
import type React from 'react';
import type { ReactNode } from 'react';

interface FeatureFlagWrapperProps {
  flag?: FeatureFlagKey; // optional: no flag, return children
  fallback?: ReactNode; // optional: what to render if flag is off
  children: ReactNode;
}

/**
 * Conditionally renders children based on a feature flag.
 */
export const FeatureFlagWrapper: React.FC<FeatureFlagWrapperProps> = ({ flag, fallback = null, children }) => {
  const { flags } = useFeatureFlags();

  if (!flag) {
    return children;
  }

  const isEnabled = flags[flag];

  if (!isEnabled) {
    return fallback;
  }

  return children;
};
